var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrop23(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2:3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 4.5,
    width: 15,
    height: 23,
    rx: 3.5,
    ry: 3.5,
    stroke: "#1f2830"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.77 17.58c2.07-1.57 2.88-2.26 2.88-3.03 0-.56-.48-.82-.97-.82-.62 0-1.1.26-1.44.64l-.54-.62c.47-.57 1.22-.86 1.97-.86 1.03 0 1.93.58 1.93 1.65 0 .98-.9 1.86-2.33 2.94h2.37v.82h-3.86v-.74ZM16.11 14.4c.3 0 .56.26.56.56s-.26.56-.56.56-.56-.26-.56-.56.26-.56.56-.56Zm0 2.89c.3 0 .56.26.56.56s-.26.56-.56.56-.56-.26-.56-.56.26-.56.56-.56ZM17.79 16.94c.34.4.91.65 1.48.65.7 0 1.11-.32 1.11-.82 0-.53-.42-.75-1.18-.75h-.62v-.84h.62c.62 0 1.1-.22 1.1-.7s-.48-.75-1.08-.75c-.54 0-.99.21-1.38.59l-.48-.58c.41-.48 1.06-.84 1.94-.84 1.15 0 1.93.54 1.93 1.44 0 .71-.61 1.13-1.16 1.22.52.05 1.24.47 1.24 1.3 0 .9-.78 1.55-2.01 1.55-.95 0-1.66-.38-2.02-.86l.5-.62Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrop23);
export default __webpack_public_path__ + "static/media/crop-2-3.eabac655a8124f49ba11e7c31dde4bec.svg";
export { ForwardRef as ReactComponent };